import { NumpadAction } from 'packages/sports/web/app/src/numpad/model';

import { BetslipPick } from '../../core/picks/betslip-pick';
import { ResultStatus } from '../../core/picks/pick-models';

export interface IEditMyBetPickState {
    isRemoved: boolean; // Pick marked as removed
    canSwap: boolean; // Pick can be swapped
    resultedState: ResultStatus; // Pick resulted state ( pick is won/lost/cancelled )
    isHighlighted: boolean; // Pick is highlighted ( after adding pick )
}

export interface IEditMyBetPicksState {
    pickList: BetslipPick[];
    pickState: Record<string, IEditMyBetPickState>;
}

export interface IEditMyBetAddPickState {
    isVisible: boolean;
    isExpanded: boolean;
    pickList: BetslipPick[];
}

export interface IEditBetSwapPickState {
    oldPick: BetslipPick | null;
    newPick: BetslipPick | null;
}

export interface IEditMyBetState {
    picks: IEditMyBetPicksState;
    originalPicks: string[];
    acceptedEarlyPayoutStake: number | null;
    earlyPayoutStake: number | null;
    isEarlyPayoutStakeLoading: boolean;
    addedStake: number;
    confirmedStake: number | null;
    addPicksState: IEditMyBetAddPickState;
    betslipId: string;
    swapPickState: IEditBetSwapPickState;
    numpadAction?: NumpadAction;
}

export const defaultEditMyBetState: IEditMyBetState = Object.freeze({
    picks: {
        pickList: [],
        pickState: {},
    },
    originalPicks: [],
    acceptedEarlyPayoutStake: null,
    earlyPayoutStake: null,
    isEarlyPayoutStakeLoading: false,
    addedStake: 0,
    confirmedStake: null,
    addPicksState: {
        isVisible: false,
        isExpanded: false,
        pickList: [],
    },
    swapPickState: {
        oldPick: null,
        newPick: null,
    },
    betslipId: '',
});
